import { type ReactNode } from 'react';

import cn from 'classnames';

import styles from './SplitRow.module.scss';

type Props = {
  start: ReactNode;
  end: ReactNode;
  reverse?: boolean;
  align?: 'center' | 'start' | 'end';
  gap?: 'sm' | 'md' | 'lg';
  className?: string;
};

export const SplitRow = ({ start, end, reverse = false, align = 'center', gap = 'md', className }: Props) => {
  return (
    <div
      className={cn(
        styles.splitRow,
        reverse && styles.splitRowReverse,
        styles[`splitRowAlign_${align}`],
        styles[`splitRowGap_${gap}`],
        className,
      )}
    >
      <div className={styles.splitRowStart}>{start}</div>
      <div className={styles.splitRowEnd}>{end}</div>
    </div>
  );
};
